import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=65fae825&"
import script from "./CheckList.vue?vue&type=script&lang=js&"
export * from "./CheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports